<template>
  <header class="header" v-if="project">

    <!-- mobil: logo + icons (Apple + Android) -->
    <div class="mobile-app-banner" v-if="isMobile">
      <img
        class="mobile-logo"
        :src="hostAddress + project.logo"
        alt="Project Logo"
      />
      <div class="mobile-app-icons">
        <a
          v-if="project.cityapp && project.cityapp.app_store_url"
          :href="project.cityapp.app_store_url"
          target="_blank"
        >
          <span class="material-icons-round" style="font-size: 28px;">apple</span>
        </a>

        <a
          v-if="project.cityapp && project.cityapp.play_store_url"
          :href="project.cityapp.play_store_url"
          target="_blank"
        >
          <img src="@/assets/icons/robot.png" alt="Android" width="20" />
        </a>
      </div>
    </div>

    <!-- desktop/iPad -->
    <div class="logo" v-if="project.logo && !isMobile">
      <img class="logo-img" :src="hostAddress + project.logo" alt="Project Logo" width="277" height="47" />
    </div>

    <div class="icon-bar" v-if="!isMobile">
      <a
        class="icon-button"
        v-if="project.cityapp && project.cityapp.app_store_url && !project.cityapp.app_store_url.toLowerCase().includes('empty')"
        :href="project.cityapp.app_store_url"
        target="_blank"
      >
        <span class="material-icons-round" style="font-size: 28px;">apple</span>
      </a>
      <a
        class="icon-button"
        v-if="project.cityapp && project.cityapp.play_store_url && !project.cityapp.play_store_url.toLowerCase().includes('empty')"
        :href="project.cityapp.play_store_url"
        target="_blank"
      >
        <img src="@/assets/icons/robot.png" alt="Android" width="20" />
      </a>
      <div class="icon-button" v-if="project.cityapp && project.cityapp.website_url">
        <span class="material-icons-round">language</span>
      </div>
      <div class="icon-button" v-if="project.cityapp && project.cityapp.facebook_url">
        <span class="material-icons-round">facebook</span>
      </div>
      <div
        class="icon-button"
        v-if="project.cityapp && project.cityapp.instagram_url"
      >
        <img src="@/assets/icons/instagram_24_24.png" alt="Instagram" width="24" />
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    project: {
      type: Object,
      required: true,
    },
    hostAddress: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isMobile: false,
    };
  },
  mounted() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
  },

};
</script>

<style scoped>
.header.header {
  height: 60px;
  background: linear-gradient(to right, rgb(205, 214, 223), rgba(255, 255, 255, 0.521));
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  font-family: "Quicksand", sans-serif;
  z-index: 40002;
  position: relative;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.027);
}

.icon-bar {
  display: flex;
  gap: 10px;
  flex-direction: row-reverse;
}

.icon-button {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
}

.icon-button:hover {
  background: #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
}

.icon-button img {
  display: block;
}


@media (max-width: 768px) {
  .mobile-app-banner {
    display: flex;
    flex-direction: row; 
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    gap: 16px;
    width: 100%;
  }

  .mobile-logo {
    height: 40px;
    width: auto;
  }

  .mobile-app-icons {
    display: flex;
    gap: 16px;
    align-items: center;
  }

  .mobile-app-icons img,
  .mobile-app-icons .material-icons-round {
    width: 28px;
    height: 28px;
  }
}


</style>
